var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paymentCode === 1)?_c('v-icon',[_vm._v("fal fa-credit-card")]):(_vm.paymentCode === 2)?_c('v-icon',[_vm._v("fal fa-ad")]):(_vm.paymentCode === 3)?_c('v-icon',[_vm._v("fal fa-ad")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }